export function equalish(a: string | undefined, b: string | undefined) {
  if (!a || !b) {
    return !a && !b;
  }

  return a.toLowerCase().replace(" ", "") === b.toLowerCase().replace(" ", "");
}
